import {isFeatureEnabled} from '@github-ui/feature-flags'
import {ThreePanesLayout} from '@github-ui/three-panes-layout'
import {useEffect} from 'react'

import {getRepoIssuesSidebarPanes} from '../../components/sidebar/get-repo-issues-sidebar-panes'
import {IssueViewsPage, RepositorySavedViewPage} from '../../lazy-routes'
import {preloadWhenIdle} from '../../utils/preload-when-idle'
import {AnalyticsWrapper} from '../AnalyticsWrapper'
import {RepositoryViewNewContent} from './RepositoryViewNewContent'

export function RepositoryViewNewPage() {
  useEffect(() => {
    return preloadWhenIdle(() => {
      IssueViewsPage.preload()
      RepositorySavedViewPage.preload()
    })
  }, [])

  if (!isFeatureEnabled('issue_pinned_views') || !isFeatureEnabled('issue_pinned_views_index_page')) {
    return null
  }

  const sidebarPanes = getRepoIssuesSidebarPanes()

  return (
    <AnalyticsWrapper category="Repository View New">
      <ThreePanesLayout
        contentAs="div"
        resizeable={false}
        leftPaneWidth="medium"
        leftPane={sidebarPanes.leftPane}
        collapsibleLeftPane={sidebarPanes.collapsibleLeftPane}
        middlePane={<RepositoryViewNewContent />}
      />
    </AnalyticsWrapper>
  )
}
